<script setup lang="ts">
/**
 * CDB54 Calendrier+ - Offline Indicator Component
 * Story 4.3: Visual indicator when offline
 */

import { useI18n } from 'vue-i18n';
import { usePwa } from '@/composables/usePwa';

const { t } = useI18n();
const { isOffline } = usePwa();
</script>

<template>
  <Transition name="slide">
    <div v-if="isOffline" class="offline-banner" role="alert" aria-live="polite">
      <i class="bi bi-wifi-off me-2"></i>
      {{ t('pwa.offline_message') }}
    </div>
  </Transition>
</template>

<style scoped>
.offline-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #ffc107;
  color: #000;
  text-align: center;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  z-index: 1050;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(100%);
}
</style>
